import { render, staticRenderFns } from "./supplier-commitment-form.vue?vue&type=template&id=554728ec&scoped=true"
import script from "./supplier-commitment-form.vue?vue&type=script&lang=js"
export * from "./supplier-commitment-form.vue?vue&type=script&lang=js"
import style0 from "./supplier-commitment-form.vue?vue&type=style&index=0&id=554728ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554728ec",
  null
  
)

export default component.exports